
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont ses points forts?`}</em></p>
    <p>{`Il utilise comme le Comirnaty la technique de l’ARN messager, ce qui permet une
adaptation plus rapide que pour les vaccins “classiques” si cela s'avère
nécessaire pour répondre à un variant. Et comme lui, son efficacité est élevée.`}</p>
    <p>{`La compagnie travaille sur un vaccin de rappel qui agit aussi contre les
variants. Les résultats de premiers essais, annoncés début mai, sont
encourageants. Le 6 mai, l'Office fédéral de la santé publique (OFSP) a annoncé
qu'un contrat a été passé avec l'entreprise pour la
`}<a parentName="p" {...{
        "href": "https://www.bag.admin.ch/bag/fr/home/das-bag/aktuell/medienmitteilungen.msg-id-83416.html"
      }}>{`livraison de sept millions de doses en 2022`}</a>{`.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;